//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import DispatchRequestListView from '@/views/Warehouse/WhDispatchRequest/list'
import DispatchRequestPendingView from '@/views/Warehouse/WhDispatchRequest/pending'
import DispatchRequestReceive from '@/views/Warehouse/WhDispatchRequest/receive'
import DispatchRequestUpdateView from '@/views/Warehouse/WhDispatchRequest/update'

/**
 *
 */
export default {
    path: 'dispatch_requests',
    component: ModuleLayout,
    children: [
        {
            name: 'dispatch-request-list',
            path: '',
            component: DispatchRequestListView,
        },
        {
            name: 'dispatch-request-pending',
            path: 'pending',
            component: DispatchRequestPendingView,
            meta: {
                title: 'Solicitud de despacho pendientes',
            },
        },
        {
            name: 'dispatch-request-update',
            path: ':id',
            component: DispatchRequestUpdateView,
            meta: {
                title: 'Detalle de solicitud de despacho',
            },
        },
        {
            name: 'wh-dispatch-request-receive',
            path: ':id/receive',
            component: DispatchRequestReceive,
            meta: {
                title: 'Recepcionar solicitud de despacho',
            },
        },
    ],
    meta: {
        title: 'Solicitudes de despacho',
    },
}
